/*!
 * KoliBri - The accessible HTML-Standard
 */
import { b as watchValidator } from './common-D-vggmh2.js';

const autoCompleteOptions = ['on', 'off'];
const validateAutoComplete = (component, value) => {
    watchValidator(component, '_autoComplete', (value) => autoCompleteOptions.includes(value) || (typeof value === 'string' && value.length > 0), new Set(autoCompleteOptions), value, {
        defaultValue: 'off',
    });
};

export { validateAutoComplete as v };
//# sourceMappingURL=auto-complete-C-QNfuIh.js.map

//# sourceMappingURL=auto-complete-C-QNfuIh.js.map